import { useTranslation } from "@impero-com/common/utils/i18n";
import { useOutletContext } from "react-router-dom";

import { AssignmentTable } from "org/user/components/AssignmentTable";
import { useTestingProgramsForUserQuery } from "org/user/queries/useTestingProgramsForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import {
    TestingProgramRow,
    useUserTestingProgramListTable,
} from "./useUserTestingProgramListTable";

export function UserTestingProgramList() {
    const { user } = useOutletContext<OutletContext>();
    const userId = user.id;

    const { data: testingPrograms } = useTestingProgramsForUserQuery(userId);
    const { t } = useTranslation();

    const { table, getFilterComponent, tableId } =
        useUserTestingProgramListTable(testingPrograms);

    const modeConfig = getFilterModeConfig(t);

    return (
        <AssignmentTable<TestingProgramRow>
            table={table}
            tableId={tableId}
            getFilterComponent={getFilterComponent}
            modeConfig={modeConfig}
        />
    );
}
